export default {"src":"/_next/static/media/ship-camps.9347db92.svg","height":40,"width":80,"blurWidth":0,"blurHeight":0};